import { FAILURE, REQUEST, SUCCESS } from '@constant/reducer-status'
import { CATEGORY } from '@constant/category'
import produce from 'immer'

const initialState = {
  data: [],
  status: false,
}

export default produce((draft, action) => {
  switch (action.type) {
    case CATEGORY.GET:
      draft.data = []
      draft.status = REQUEST
      break
    case CATEGORY.GET_SUCCESS:
      draft.data = action.payload.data
      draft.status = SUCCESS
      break
    case CATEGORY.GET_FAILURE:
      draft.data = []
      draft.status = FAILURE
      break
  }
}, initialState)
